/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VoiceSettings } from '../../models/voice-settings';
import { VoiceSettingsUpdateRequest } from '../../models/voice-settings-update-request';

export interface UpdateVoiceSettings$Params {
  organizationSiteKey: KeyType;
      body: VoiceSettingsUpdateRequest
}

export function updateVoiceSettings(http: HttpClient, rootUrl: string, params: UpdateVoiceSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<VoiceSettings>> {
  const rb = new RequestBuilder(rootUrl, updateVoiceSettings.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VoiceSettings>;
    })
  );
}

updateVoiceSettings.PATH = '/organization-sites/{organizationSiteKey}/voice-settings';
